import { getAuthHeaders } from './authHeaders';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export async function adminListActiveCouriers() {
  console.log('🛠️ AdminLiveTrackingAPI: listActiveCouriers start');

  const headers = await getAuthHeaders();
  const url = `${API_BASE_URL}/orders/couriers`;

  const response = await fetch(url, { method: 'GET', headers });
  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    console.error('🛠️ AdminLiveTrackingAPI: listActiveCouriers failed', err);
    throw err;
  }

  const data = await response.json();
  console.log('🛠️ AdminLiveTrackingAPI: listActiveCouriers ok count=', data?.couriers?.length || 0);
  return data;
}

export async function adminAssignCourierToOrder(orderCode, courierId) {
  console.log('🛠️ AdminLiveTrackingAPI: assignCourier start', { orderCode, courierId });

  const headers = await getAuthHeaders({
    'Content-Type': 'application/json',
  });

  const url = `${API_BASE_URL}/orders/${encodeURIComponent(orderCode)}/courier/assign`;
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ courier_id: courierId }),
  });

  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    console.error('🛠️ AdminLiveTrackingAPI: assignCourier failed', err);
    throw err;
  }

  const data = await response.json();
  console.log('🛠️ AdminLiveTrackingAPI: assignCourier ok', data);
  return data;
}

export async function adminCreateTrackingToken(orderCode) {
  console.log('🛠️ AdminLiveTrackingAPI: createTrackingToken start', { orderCode });

  const headers = await getAuthHeaders({
    'Content-Type': 'application/json',
  });

  const url = `${API_BASE_URL}/orders/${encodeURIComponent(orderCode)}/tracking-token`;
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    console.error('🛠️ AdminLiveTrackingAPI: createTrackingToken failed', err);
    throw err;
  }

  const data = await response.json();
  console.log('🛠️ AdminLiveTrackingAPI: createTrackingToken ok', data);
  return data;
}

export async function adminGetOrderProgress(orderCode) {
  const oc = String(orderCode || '').trim();
  console.log('🛠️ AdminLiveTrackingAPI: getOrderProgress start', { orderCode: oc });

  if (!oc) {
    throw new Error('ORDER_CODE_REQUIRED');
  }

  const headers = await getAuthHeaders();
  const url = `${API_BASE_URL}/orders/${encodeURIComponent(oc)}/progress`;

  const response = await fetch(url, { method: 'GET', headers });
  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    console.error('🛠️ AdminLiveTrackingAPI: getOrderProgress failed', err);
    throw err;
  }

  const data = await response.json();
  console.log('🛠️ AdminLiveTrackingAPI: getOrderProgress ok', data);
  return data;
}
